export default "__VITE_ASSET__DHhE0tCi__"